const FormatRefFriendObject = function(currentRef){
    // Clone object for avoid reactivity
    const formatedRef = JSON.parse(JSON.stringify(currentRef))


    Object.assign(formatedRef, formatedRef.sight3_scores)

    const localCoeffsArray = Object.entries(formatedRef.coeffs)
    localCoeffsArray.forEach(function(element) {
        formatedRef[`${element[0]}_coeff`] = element[1]
    })
    delete formatedRef['sight3_scores']
    delete formatedRef['sight2_scores']
    delete formatedRef['coeffs']
    delete formatedRef['sight_ref']

    return formatedRef
}
export default FormatRefFriendObject
